export const CREATE_RATE_CARD_DATA : string = "CREATE_RATE_CARD_DATA";
export const GET_RATE_CARD_DATA : string = "GET_RATE_CARD_DATA";
export const LOADING: string = "LOADING";

